"use client"

import {createContext, useContext, useEffect, useMemo, useState} from 'react';
import {usePathname} from "next/navigation";
import {useWebSiteContext} from "@core/helpers/client/contexts/WebSiteContext";

export const BlankContext = createContext(null);

const trim_slashes = (path) => String(path || "").replace(/\/+$/, "");

// Optional props (mahya-tajhiz, its own BlankContextProvider in contexts/PageContext.jsx); without them nothing changes.
// - `blank_on_auth`: the login page (`web_route_names.auth`, "/auth/" without one) is blank from the server HTML on,
//   not only after the login form calls `set_is_blank(true)` once hydrated (header and footer flashed, then went).
// - `reset_on_navigation={false}`: `set_is_blank(true)` is not undone when the pathname changes.
export const BlankContextProvider = ({children, blank_on_auth = false, reset_on_navigation = true}) => {

    const pathname = usePathname();
	const [blank_state, set_is_blank] = useState(false);
	const {web_route_names} = useWebSiteContext() || {};
	const auth_path = blank_on_auth ? trim_slashes(web_route_names?.["auth"] || "/auth/") : "";
	const is_blank = blank_state || (auth_path !== "" && trim_slashes(pathname) === auth_path);

	useEffect(() => {
		if (reset_on_navigation && blank_state) {
			set_is_blank(false)
		}
	}, [pathname]);

	const values = useMemo(() => ({
		is_blank,
		set_is_blank
	}), [is_blank]);


	return (
		<BlankContext.Provider value={{...values}}>
			{children}
		</BlankContext.Provider>
	);
};

export const useBlankContext = () => useContext(BlankContext)